/**
 * The public branch: everything reachable without a session.
 *
 * Sign-in and unlock are **not** lazy. They are the first screen a cold start shows, and a
 * separate chunk for them means a network round trip between the app booting and the user being
 * able to type — on a shop's mobile data, the slowest possible place to save 6 KB.
 *
 * `Component:` rather than `element:` throughout, so a route branch stays a plain `.ts` data
 * file with no JSX in it.
 */

import type { RouteObject } from 'react-router';

import { SignInPage } from '@/pages/SignInPage';
import { UnlockPage } from '@/pages/UnlockPage';

export const publicRoutes: RouteObject[] = [
  { path: 'sign-in', Component: SignInPage, handle: { title: 'Sign in' } },
  { path: 'unlock', Component: UnlockPage, handle: { title: 'Unlock' } },
];
